import React from 'react';
import { Text, View } from 'react-native';
import {
  Dollar_35000, iMessage, orOperator_123456_78, welcome_Text,
} from '../../../../utils/DictionaryManagementUtils';
import { getBoldFont, getRegularFont, xlateText } from '../../../../utils/Utils';
import { textPrimary_7_0 } from '../TextComponent/TextStyle';

const MenuInfoLayout = ({
  globJSON,
  simPlatform,
  force_display = false,
}) => {
  const isIMessage = simPlatform === iMessage;

  const { colors } = globJSON.configurations.theme;
  const { radius } = globJSON.configurations.theme;
  const { menu } = globJSON.configurations.services;
  const styles = {
    containerInfo: {
      backgroundColor: colors.menu_top_area_color,
      paddingStart: 17,
      paddingEnd: 17,
      paddingBottom: 10,
    },
    lblWelcome: {
      fontFamily: `${getBoldFont(globJSON, simPlatform)}`,
      fontSize: 10,
      alignSelf: 'center',
      marginTop: 10,
      color: colors.menu_primary_color,
    },
    whiteBackground: {
      backgroundColor: colors.menu_balance_color,
      borderRadius: radius.elements_shape_square ? 3 : 9,
      padding: 5,
      marginTop: 7,
    },
    viewBalance: {
      flexDirection: 'row',
      display: 'flex',
      alignSelf: 'center',
      fontSize: 7,
      fontFamily: `${getRegularFont(globJSON, simPlatform)}`,
    },
    lblAccountNumber: {
      fontFamily: `${getRegularFont(globJSON, simPlatform)}`,
      fontSize: 7,
      color: globJSON.configurations.theme.colors.menu_secondary_color,
    },
    viewCost: {
      alignSelf: 'center',
      fontSize: 10,
      color: globJSON.configurations.theme.colors.menu_secondary_color,
    },

  };

  return (
    <View style={styles.containerInfo}>
      {force_display || (menu.welcome_title && !isIMessage) ? (
        <Text style={styles.lblWelcome}>{xlateText(welcome_Text)}</Text>
      ) : null}

      {(force_display || menu.show_account_balance) && (
        <View style={styles.whiteBackground}>
          <View style={styles.viewBalance}>
            <Text
              style={[textPrimary_7_0(globJSON, simPlatform), { color: colors.menu_secondary_color }]}
            >
              {menu.current_account}
            </Text>
            <Text
              style={[textPrimary_7_0(globJSON, simPlatform), { color: colors.menu_secondary_color }]}
            >
              {orOperator_123456_78}
            </Text>
          </View>
          <Text style={styles.viewCost}>{Dollar_35000}</Text>
        </View>
      )}

    </View>

  );
};
export default MenuInfoLayout;
